import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls window to the top on every route change.
 * Preserves intentional in-page anchor jumps (e.g. /#services) — only resets when
 * the path changes without a hash, or the hash is empty.
 */
export const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return; // let anchor scroll happen
    // Defer one tick so route content mounts first
    const id = window.requestAnimationFrame(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" in window ? "instant" : "auto" });
    });
    return () => window.cancelAnimationFrame(id);
  }, [pathname, hash]);
  return null;
};
